import { createFileRoute } from "@tanstack/react-router";
import { site, pageUrl } from "@/data/site";
import { Breadcrumbs, PageHeader, Section } from "@/components/site/section";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy | Paul's Pens n Things" },
      {
        name: "description",
        content:
          "What information Paul's Pens n Things collects when you send a custom request, how it is used, and how to ask for it to be deleted.",
      },
      { property: "og:title", content: "Privacy Policy | Paul's Pens n Things" },
      { property: "og:description", content: "How your details are used when you contact the workshop." },
      { property: "og:url", content: pageUrl("/privacy") },
    ],
    links: [{ rel: "canonical", href: pageUrl("/privacy") }],
  }),
  component: Privacy,
});

function Privacy() {
  return (
    <>
      <Breadcrumbs trail={[{ label: "Home", to: "/" }, { label: "Privacy Policy" }]} />
      <PageHeader eyebrow="Legal" title="Privacy Policy" lede="Plain language, because this is a one-person workshop." />
      <Section className="pt-0">
        <div className="shell max-w-prose space-y-6 text-base leading-relaxed text-ink/85">
          <p>
            When you send a request or contact Paul, he receives the details you choose to provide — typically your
            name, email address, phone number if you give one, and the description, photos or files attached to your
            project.
          </p>
          <h2 className="font-[family-name:var(--font-display)] text-2xl text-ink">How it is used</h2>
          <p>
            Only to reply to you, discuss your project, and complete an order if you go ahead. Paul does not sell,
            rent or share your details with anyone for marketing.
          </p>
          <h2 className="font-[family-name:var(--font-display)] text-2xl text-ink">Payments</h2>
          <p>
            Payments are handled entirely through PayPal invoices. Paul never sees or stores your card details.
            PayPal's own privacy terms apply to that part of the transaction.
          </p>
          <h2 className="font-[family-name:var(--font-display)] text-2xl text-ink">Analytics</h2>
          <p>
            This site may use privacy-respecting analytics to understand which pages are useful. This data is
            aggregated and is not used to identify you personally.
          </p>
          <h2 className="font-[family-name:var(--font-display)] text-2xl text-ink">Keeping and deleting data</h2>
          <p>
            Correspondence is kept for as long as it is useful for warranty, repeat orders and record-keeping. You can
            ask Paul to delete your details at any time by emailing{" "}
            <a href={`mailto:${site.email}`} className="underline underline-offset-4">
              {site.email}
            </a>
            .
          </p>
          <p className="text-sm text-muted-foreground">
            Questions about this policy can be sent to {site.email} or {site.phoneDisplay}.
          </p>
        </div>
      </Section>
    </>
  );
}
